<app-ace-select #aceSelect
                bindValue="value"
                bindLabel="label"
                [items]="allOptions"
                [placeholder]="placeholder | messageTranslate"
                [loading]="loading"
                [hideSelected]="hideSelected"
                [appendTo]="appendTo"
                [clearable]="clearable"
                [isReadOnly]="readOnly"/>
